/*!
 * Keplin Reviews JS
 * Anyone can write a review — no purchase required, no eligibility check.
 * Guests supply email. Dedup is handled server-side on submit.
 *
 * Rendering note: the first page of reviews ships server-rendered from
 * Liquid (see product-reviews.liquid) to avoid layout shift on load.
 * This script only rebuilds #kpln-rv-list once the person actually
 * interacts (search / filter / sort / media toggle / pagination) — at
 * boot it just hydrates state + wires up events against the existing
 * server-rendered markup.
 */
(function () {
  'use strict';

  var RV = window.__KPLN_RV;
  if (!RV) return;

  var PRODUCT_ID     = RV.productId;
  var PRODUCT_HANDLE = RV.productHandle;
  var PRODUCT_TITLE  = RV.productTitle;
  var BASE           = (RV.reviewsUrl || 'http://127.0.0.1:8787').replace(/\/$/, '');
  var AUTH           = RV.auth || '';
  var CUSTOMER_ID    = RV.customerId    || '';
  var CUSTOMER_EMAIL = RV.customerEmail || '';
  var CUSTOMER_NAME  = RV.customerName  || '';
  var IS_LOGGED_IN   = !!RV.isLoggedIn;

  var ALL_REVIEWS = RV.reviews    || [];
  var STATS       = RV.stats      || { avg:0, count:0, dist:{}, rec_pct:0 };
  var SUMMARY     = RV.summary    || '';
  var HIGHLIGHTS  = RV.highlights || {};

  var PAGE_SIZE      = RV.pageSize || 8;
  var currentRating  = 0;      // 0 = all
  var currentSort    = 'newest';
  var currentSearch  = '';
  var mediaOnly      = false;
  var currentPage    = 1;
  var filteredList   = ALL_REVIEWS.slice(); // matches server-rendered order at boot
  var hasRendered    = false;  // becomes true the first time JS rebuilds the list
  var pendingPhotos  = [];     // locally-cached photos {id,dataUrl,filename} — uploaded on submit
  var pendingSeq     = 0;
  var galleryPhotos  = [];

  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function fmtDate(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('en-GB', {day:'2-digit',month:'short',year:'numeric'});
    } catch(e) { return iso; }
  }

  function starsSVG(r, cls, size) {
    var h = '';
    for (var i=1;i<=5;i++) {
      h += '<svg width="'+(size||14)+'" height="'+(size||14)+'" viewBox="0 0 24 24">' +
        '<polygon class="'+(i<=r?cls+'-on':cls+'-off')+'" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>';
    }
    return h;
  }

  function initials(name) {
    name = (name || '').trim();
    if (!name) return '?';
    var parts = name.split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length-1].charAt(0)).toUpperCase();
  }

  function attrLabel(v) {
    if (v >= 4.5) return 'Excellent';
    if (v >= 3.5) return 'Very Good';
    if (v >= 3)   return 'Good';
    if (v >= 2)   return 'Fair';
    return 'Poor';
  }

  /* ---------------- Overall + attribute sliders ---------------- */

  function renderOverall() {
    var avgEl=$('kpln-rv-avg'),starsEl=$('kpln-rv-stars-row'),totEl=$('kpln-rv-total-link');
    if(avgEl)   avgEl.textContent=STATS.avg||'';
    if(starsEl) starsEl.innerHTML=starsSVG(Math.round(STATS.avg||0),'kr-s',18);
    if(totEl)   totEl.textContent='Based on '+(STATS.count||ALL_REVIEWS.length)+' reviews';
    if(totEl) totEl.addEventListener('click',function(){
      var list=$('kpln-rv-list');
      if(list) window.scrollTo({top:list.getBoundingClientRect().top+window.scrollY-80,behavior:'smooth'});
    });
  }

  function renderAttrs() {
    var wrap = $('kpln-rv-attrs');
    if (!wrap) return;
    var attrs = STATS.attributes;
    if (!attrs) return; // no attribute data yet — leave hidden
    var order = ['appearance','quality','value','performance'];
    var labels = {appearance:'Appearance',quality:'Quality',value:'Value',performance:'Performance'};
    var html = '';
    order.forEach(function(key){
      if (attrs[key] == null) return;
      var v = parseFloat(attrs[key]) || 0;
      var pct = Math.max(0, Math.min(100, (v/5)*100));
      html += '<div class="kpln-rv__attr">' +
        '<div class="kpln-rv__attr-label">'+labels[key]+'</div>' +
        '<div class="kpln-rv__attr-track">' +
          '<div class="kpln-rv__attr-fill" style="width:'+pct+'%"></div>' +
          '<div class="kpln-rv__attr-dot" style="left:'+pct+'%"></div>' +
        '</div>' +
        '<div class="kpln-rv__attr-tag">'+attrLabel(v)+'</div>' +
      '</div>';
    });
    if (html) { wrap.innerHTML = html; wrap.style.display = 'grid'; }
  }

  function renderSummary() {
    var bullets=HIGHLIGHTS.bullets, ulEl=$('kpln-rv-ai-bullets'), moreBtn=$('kpln-rv-ai-more');
    if(!ulEl) return;
    var lines=[];
    if(bullets&&bullets.length){ lines=bullets; }
    else if(SUMMARY){ var parts=SUMMARY.split(/(?<=[.!?])\s+|—|–/); lines=parts.map(function(l){return l.trim();}).filter(Boolean).slice(0,3); }
    if(!lines.length) return;
    var showAll=false,max=3;
    function render(){
      ulEl.innerHTML='';
      (showAll?lines:lines.slice(0,max)).forEach(function(l){var li=document.createElement('li');li.textContent=l;ulEl.appendChild(li);});
      if(moreBtn){moreBtn.style.display=lines.length>max?'block':'none';moreBtn.textContent=showAll?'Show less':'Show more';}
    }
    render();
    if(moreBtn) moreBtn.addEventListener('click',function(){showAll=!showAll;render();});
  }

  /* ---------------- Customer photo gallery (simple horizontal scroll) ---------------- */

  function renderGallery() {
    galleryPhotos = [];
    ALL_REVIEWS.forEach(function(r){ if(r.photos&&r.photos.length) r.photos.forEach(function(u){galleryPhotos.push(u);}); });
    if(!galleryPhotos.length) return;
    var gallery=$('kpln-rv-gallery'), strip=$('kpln-rv-gallery-strip');
    if(!gallery||!strip) return;
    gallery.style.display='';
    strip.innerHTML = galleryPhotos.map(function(url, i){
      return '<img src="'+esc(url)+'?width=400" class="kpln-rv__gallery-thumb" loading="lazy" width="200" height="200" alt="Customer photo" data-gi="'+i+'">';
    }).join('');

    strip.addEventListener('click', function(e){
      var img = e.target.closest('.kpln-rv__gallery-thumb');
      if (!img) return;
      openLightbox(galleryPhotos, parseInt(img.dataset.gi, 10));
    });
  }

  /* ---------------- Filter / sort / search (user-triggered only) ---------------- */

  function applyFilterSort() {
    var list = ALL_REVIEWS.slice();
    if (currentRating > 0) list = list.filter(function(r){ return r.rating === currentRating; });
    if (mediaOnly) list = list.filter(function(r){ return r.photos && r.photos.length > 0; });
    if (currentSearch) {
      var q = currentSearch.toLowerCase();
      list = list.filter(function(r){
        return (r.title||'').toLowerCase().indexOf(q) > -1 ||
               (r.body||'').toLowerCase().indexOf(q) > -1 ||
               (r.customerName||'').toLowerCase().indexOf(q) > -1;
      });
    }
    if(currentSort==='highest')     list.sort(function(a,b){return b.rating-a.rating;});
    else if(currentSort==='lowest') list.sort(function(a,b){return a.rating-b.rating;});
    else list.sort(function(a,b){return new Date(b.createdAt)-new Date(a.createdAt);});
    filteredList=list; currentPage=1; renderPage();
  }

  /* ---------------- Card rendering (client-side re-render only) ---------------- */

  function renderPage() {
    var listEl=$('kpln-rv-list'); if(!listEl) return;
    hasRendered = true;
    var total=filteredList.length,start=(currentPage-1)*PAGE_SIZE,end=Math.min(start+PAGE_SIZE,total),page=filteredList.slice(start,end);
    listEl.innerHTML='';
    page.forEach(function(r,idx){ listEl.insertAdjacentHTML('beforeend',buildCard(r,start+idx)); });
    updateMetaUI(total,start,end);
  }

  function updateMetaUI(total,start,end){
    if (total === undefined) {
      total = filteredList.length;
      start = (currentPage-1)*PAGE_SIZE;
      end = Math.min(start+PAGE_SIZE,total);
    }
    var showing=total>0?(start+1)+'–'+end+' of '+total+' Review'+(total!==1?'s':''):'0 Reviews';
    var pageInfoEl=$('kpln-rv-page-info');
    if(pageInfoEl) pageInfoEl.textContent=showing;
    var prevBtn=$('kpln-rv-prev'),nextBtn=$('kpln-rv-next');
    if(prevBtn) prevBtn.disabled=currentPage===1;
    if(nextBtn) nextBtn.disabled=end>=total;
  }

  function buildImagesCol(r, dataIdx) {
    var photos = r.photos || [];
    var dateHtml = '<div class="kpln-rv__c-date">'+fmtDate(r.createdAt)+'</div>';
    if (!photos.length) {
      return '<div class="kpln-rv__c-images" data-idx="'+dataIdx+'">'+dateHtml+'</div>';
    }
    if (photos.length === 1) {
      return '<div class="kpln-rv__c-images" data-idx="'+dataIdx+'">'+dateHtml+
        '<img src="'+esc(photos[0])+'" class="kpln-rv__c-img-single" loading="lazy" alt="Review photo" data-idx="'+dataIdx+'" data-pi="0">' +
      '</div>';
    }
    // 2+ images — up to 4 shown in a 2x2 grid; clicking anywhere opens the lightbox at the first photo
    var extra = photos.length - 4;
    var grid = photos.slice(0, 4).map(function(u, pi){
      var isMoreTile = (pi === 3 && photos.length > 4);
      return '<img src="'+esc(u)+'"'+(isMoreTile?' class="kr-more" data-more="+'+extra+'"':'')+' loading="lazy" alt="Review photo">';
    }).join('');
    return '<div class="kpln-rv__c-images" data-idx="'+dataIdx+'">'+dateHtml+
      '<div class="kpln-rv__c-img-grid" data-idx="'+dataIdx+'" data-pi="0">'+grid+'</div>' +
    '</div>';
  }

  function buildCard(r, dataIdx) {
    return '<div class="kpln-rv__card" data-idx="'+dataIdx+'">' +
      '<div class="kpln-rv__c-meta">' +
        '<div class="kpln-rv__avatar">'+esc(initials(r.customerName))+'</div>' +
        '<div class="kpln-rv__c-meta-text">' +
          '<div class="kpln-rv__c-name">'+esc(r.customerName||'Anonymous')+'</div>' +
          '<span class="rv-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" width="11" height="11"><polyline points="20 6 9 17 4 12"/></svg>Verified Buyer</span>' +
        '</div>' +
      '</div>' +
      '<div class="kpln-rv__c-content">' +
        '<div class="kpln-rv__card-stars-row">'+starsSVG(r.rating,'kr-c',15)+'</div>' +
        (r.title?'<p class="kpln-rv__card-title">'+esc(r.title)+'</p>':'') +
        '<p class="kpln-rv__card-body">'+esc(r.body)+'</p>' +
      '</div>' +
      buildImagesCol(r, dataIdx) +
    '</div>';
  }

  // Click delegation covers both server-rendered and client-rendered cards —
  // single image (data-pi on the <img>) or the 2x2 grid (data-pi on the wrapper).
  var listEl=$('kpln-rv-list');
  if(listEl) listEl.addEventListener('click',function(e){
    var target = e.target.closest('[data-pi]');
    if(!target) return;
    var idx=parseInt(target.dataset.idx,10), pi=parseInt(target.dataset.pi,10) || 0;
    var r=filteredList[idx];
    if(r && r.photos && r.photos.length) openLightbox(r.photos, pi);
  });

  var prevBtn=$('kpln-rv-prev'),nextBtn=$('kpln-rv-next');
  if(prevBtn) prevBtn.addEventListener('click',function(){if(currentPage>1){currentPage--;renderPage();scrollTop();}});
  if(nextBtn) nextBtn.addEventListener('click',function(){if(currentPage*PAGE_SIZE<filteredList.length){currentPage++;renderPage();scrollTop();}});
  function scrollTop(){var el=$('kpln-rv-list');if(el) window.scrollTo({top:el.getBoundingClientRect().top+window.scrollY-80,behavior:'smooth'});}

  /* ---------------- Toolbar wiring ---------------- */

  var searchInput = $('kpln-rv-search');
  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function(){
      clearTimeout(searchTimer);
      var val = this.value;
      searchTimer = setTimeout(function(){ currentSearch = val.trim(); applyFilterSort(); }, 250);
    });
  }

  var mediaToggle = $('kpln-rv-media-toggle');
  if (mediaToggle) mediaToggle.addEventListener('click', function(){
    mediaOnly = this.getAttribute('aria-pressed') !== 'true';
    this.setAttribute('aria-pressed', mediaOnly ? 'true' : 'false');
    applyFilterSort();
  });

  /* ---------------- Custom shadcn-style Select component ---------------- */

  function initSelect(root, onChange) {
    if (!root) return;
    var trigger = root.querySelector('.rv-select-trigger');
    var valueEl = root.querySelector('.rv-select-value');
    var items   = Array.prototype.slice.call(root.querySelectorAll('.rv-select-item'));
    var activeIndex = -1;

    function highlight(){ items.forEach(function(it,i){ it.classList.toggle('is-active', i===activeIndex); }); }
    function onDocClick(e){ if(!root.contains(e.target)) close(); }
    function onKeydown(e){
      if(e.key==='Escape'){ close(); trigger.focus(); return; }
      if(e.key==='ArrowDown'){ e.preventDefault(); activeIndex=Math.min(items.length-1, activeIndex+1); highlight(); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); activeIndex=Math.max(0, activeIndex-1); highlight(); }
      else if(e.key==='Enter'){ e.preventDefault(); if(activeIndex>=0) select(items[activeIndex]); }
    }
    function open(){
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded','true');
      activeIndex = items.findIndex(function(i){ return i.getAttribute('aria-selected')==='true'; });
      highlight();
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKeydown);
    }
    function close(){
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded','false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKeydown);
    }
    function select(item){
      items.forEach(function(it){ it.setAttribute('aria-selected', it===item ? 'true':'false'); });
      root.dataset.value = item.dataset.value;
      if(valueEl) valueEl.textContent = item.textContent.trim();
      close();
      onChange(item.dataset.value);
    }

    trigger.addEventListener('click', function(){ root.classList.contains('is-open') ? close() : open(); });
    items.forEach(function(item){
      item.addEventListener('click', function(){ select(item); });
      item.addEventListener('mouseenter', function(){ activeIndex=items.indexOf(item); highlight(); });
    });
  }

  initSelect($('kpln-rv-rating-select'), function(value){
    currentRating = parseInt(value, 10) || 0;
    applyFilterSort();
  });

  initSelect($('kpln-rv-sort'), function(value){
    currentSort = value;
    applyFilterSort();
  });

  /* ---------------- Lightbox with arrow navigation ---------------- */

  var lbImages = [];
  var lbIndex  = 0;

  function renderLightbox() {
    var fi=$('kpln-rv-fs-img'), countEl=$('kpln-rv-fs-count');
    if (!fi) return;
    fi.src = lbImages[lbIndex];
    if (countEl) countEl.textContent = lbImages.length > 1 ? (lbIndex+1)+' / '+lbImages.length : '';
    var prevBtn=$('kpln-rv-fs-prev'), nextBtn=$('kpln-rv-fs-next');
    var multi = lbImages.length > 1;
    if (prevBtn) prevBtn.style.display = multi ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = multi ? 'flex' : 'none';
  }

  function openLightbox(images, startIndex) {
    lbImages = images || [];
    lbIndex  = startIndex || 0;
    if (!lbImages.length) return;
    var fs=$('kpln-rv-fs');
    if (!fs) return;
    renderLightbox();
    fs.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox(){
    var fs=$('kpln-rv-fs'), fi=$('kpln-rv-fs-img');
    if(fs) fs.classList.remove('is-open');
    if(fi) fi.src='';
    document.body.style.overflow = '';
  }
  function lbPrev(){ if(!lbImages.length) return; lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length; renderLightbox(); }
  function lbNext(){ if(!lbImages.length) return; lbIndex = (lbIndex + 1) % lbImages.length; renderLightbox(); }

  var fsX=$('kpln-rv-fs-x'), fsBg=$('kpln-rv-fs'), fsPrev=$('kpln-rv-fs-prev'), fsNext=$('kpln-rv-fs-next');
  if(fsX) fsX.addEventListener('click',closeLightbox);
  if(fsBg) fsBg.addEventListener('click',function(e){if(e.target===fsBg)closeLightbox();});
  if(fsPrev) fsPrev.addEventListener('click',function(e){e.stopPropagation();lbPrev();});
  if(fsNext) fsNext.addEventListener('click',function(e){e.stopPropagation();lbNext();});
  document.addEventListener('keydown',function(e){
    var fs=$('kpln-rv-fs');
    if (fs && fs.classList.contains('is-open')) {
      if(e.key==='Escape') closeLightbox();
      else if(e.key==='ArrowLeft') lbPrev();
      else if(e.key==='ArrowRight') lbNext();
    }
  });

  /* ---------------- Write review — open to everyone ---------------- */

  function openForm(){
    var fw=$('kpln-rv-form-wrap'),dv=$('kpln-rv-divider'),fr=$('kpln-rv-form');
    if(fw) fw.classList.add('is-open');
    if(dv) dv.classList.add('is-open');
    if(fr) fr.style.display='block';
    if(fw) fw.scrollIntoView({behavior:'smooth',block:'start'});
  }
  function closeForm(){
    var fw=$('kpln-rv-form-wrap'),dv=$('kpln-rv-divider');
    if(fw)fw.classList.remove('is-open');
    if(dv)dv.classList.remove('is-open');
  }

  var writeBtns = document.querySelectorAll('#kpln-rv-write-btn');
  writeBtns.forEach(function(btn){ btn.addEventListener('click', openForm); });

  var cancelBtn=$('kpln-rv-cancel');
  if(cancelBtn) cancelBtn.addEventListener('click',closeForm);

  // Star picker
  (function(){
    var p=$('kpln-rv-star-pick');if(!p)return;
    var labels=p.querySelectorAll('label'),inputs=p.querySelectorAll('input[type=radio]');
    function paint(v){labels.forEach(function(l,i){l.style.color=i<v?'#f5a623':'#ccc';});}
    labels.forEach(function(l,i){
      l.addEventListener('mouseenter',function(){paint(i+1);});
      l.addEventListener('mouseleave',function(){var c=p.querySelector('input:checked');paint(c?parseInt(c.value,10):0);});
    });
    inputs.forEach(function(inp){inp.addEventListener('change',function(){paint(parseInt(this.value,10));});});
  })();

  // Photo picker — held locally (in pendingPhotos) and only uploaded when the
  // review is submitted. Nothing hits the network at pick time.
  var ua=$('kpln-rv-upload'),fi=$('kpln-rv-file'),pr=$('kpln-rv-photos');
  if(ua&&fi){
    ua.addEventListener('click',function(e){if(!e.target.closest('.kpln-rv__pt-rm'))fi.click();});
    ua.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')fi.click();});
    ua.addEventListener('dragover',function(e){e.preventDefault();ua.style.borderColor='#052740';});
    ua.addEventListener('dragleave',function(){ua.style.borderColor='';});
    ua.addEventListener('drop',function(e){e.preventDefault();ua.style.borderColor='';handleFiles(e.dataTransfer.files);});
    fi.addEventListener('change',function(){handleFiles(fi.files);fi.value='';});
  }
  function handleFiles(files){
    var rem=3-pendingPhotos.length;if(rem<=0)return;
    Array.from(files).slice(0,rem).forEach(function(f){
      if(!f.type.match(/image\/(jpeg|png|webp)/))return;
      if(f.size>5*1024*1024){setMsg('Image too large (max 5MB).','error');return;}
      var r=new FileReader();r.onload=function(e){addPendingPhoto(e.target.result,f.name);};r.readAsDataURL(f);
    });
  }
  function addPendingPhoto(dataUrl,fname){
    var id='p'+(pendingSeq++);
    pendingPhotos.push({id:id,dataUrl:dataUrl,filename:fname});
    var thumb=document.createElement('div');thumb.className='kpln-rv__pt';thumb.setAttribute('data-id',id);
    thumb.innerHTML='<img src="'+dataUrl+'" alt="Review photo"><button type="button" class="kpln-rv__pt-rm" data-id="'+id+'">&times;</button>';
    if(pr) pr.appendChild(thumb);
  }
  if(pr) pr.addEventListener('click',function(e){
    var rm=e.target.closest('.kpln-rv__pt-rm');if(!rm)return;
    var id=rm.getAttribute('data-id');
    pendingPhotos=pendingPhotos.filter(function(p){return p.id!==id;});
    var t=rm.closest('.kpln-rv__pt');if(t) t.remove();
  });

  // Upload all locally-cached photos now; resolve with the array of hosted URLs.
  function uploadPendingPhotos(){
    if(!pendingPhotos.length) return Promise.resolve([]);
    return Promise.all(pendingPhotos.map(function(p){
      return fetch(BASE+'/reviews/upload-image',{
        method:'POST',headers:{'Content-Type':'application/json','X-Keplin-Auth':AUTH},
        body:JSON.stringify({image:p.dataUrl,filename:p.filename})
      }).then(function(r){return r.json();}).then(function(d){
        if(d&&d.url) return d.url;
        throw new Error('Photo upload failed: '+((d&&d.error)||'unknown'));
      });
    }));
  }

  function setSubmitLoading(sb,on){
    if(!sb) return;
    sb.disabled=!!on;
    sb.textContent=on?'Submitting…':'Submit Review';
  }

  // Replace the dialog card contents with a clean, centred success state.
  function showSuccess(discountCode){
    var box=document.querySelector('#kpln-rv-form-wrap .kpln-rv__form-box');
    if(!box){ setMsg('Thank you for your review! It will appear once approved.','success'); return; }
    var reward='';
    if(discountCode){
      var applyUrl='/discount/'+encodeURIComponent(discountCode)+'?redirect=/';
      reward=''+
        '<div style="margin-top:22px;background:var(--rv-muted);border:1px solid var(--rv-border);border-radius:12px;padding:20px 18px;">'+
          '<p style="margin:0 0 6px;font-size:11px;font-weight:700;color:var(--rv-muted-foreground);text-transform:uppercase;letter-spacing:.08em;">Your reward for adding a photo</p>'+
          '<p style="margin:0 0 16px;font-size:26px;font-weight:800;letter-spacing:.12em;color:var(--rv-primary);">'+esc(discountCode)+'</p>'+
          '<div style="display:flex;gap:10px;flex-wrap:wrap;justify-content:center;">'+
            '<a class="rv-btn rv-btn--primary" href="'+applyUrl+'" style="text-decoration:none;">Apply code &amp; shop</a>'+
            '<button type="button" class="rv-btn rv-btn--outline" id="kpln-rv-copy" data-code="'+esc(discountCode)+'">Copy code</button>'+
          '</div>'+
        '</div>';
    }
    box.innerHTML=''+
      '<div style="text-align:center;padding:12px 4px 6px;">'+
        '<div style="width:56px;height:56px;margin:0 auto 14px;border-radius:50%;background:var(--rv-primary);color:#fff;display:flex;align-items:center;justify-content:center;font-size:28px;line-height:1;">✓</div>'+
        '<p style="margin:0 0 6px;font-size:20px;font-weight:700;color:var(--rv-foreground);">Thank you for your review!</p>'+
        '<p style="margin:0;font-size:14px;color:var(--rv-muted-foreground);">It will appear once approved.</p>'+
        reward+
        '<div style="margin-top:22px;"><button type="button" class="rv-btn rv-btn--ghost" id="kpln-rv-done">Close</button></div>'+
      '</div>';
    var doneBtn=document.getElementById('kpln-rv-done');
    if(doneBtn) doneBtn.addEventListener('click',closeForm);
    var copyBtn=document.getElementById('kpln-rv-copy');
    if(copyBtn) copyBtn.addEventListener('click',function(){
      var code=this.getAttribute('data-code'),self=this;
      function done(){ self.textContent='Copied!'; setTimeout(function(){self.textContent='Copy code';},1600); }
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done,done); }
      else { done(); }
    });
  }

  // Form submit
  var form=$('kpln-rv-form');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var sb=$('kpln-rv-submit');if(sb&&sb.disabled)return;
      var rEl=form.querySelector('input[name="rating"]:checked');
      var rating=rEl?parseInt(rEl.value,10):0;
      var name  =($('kpln-rv-name')?$('kpln-rv-name').value.trim():'')||CUSTOMER_NAME;
      var email =($('kpln-rv-email')?$('kpln-rv-email').value.trim():'');
      var title =$('kpln-rv-title')?$('kpln-rv-title').value.trim():'';
      var body  =$('kpln-rv-body') ?$('kpln-rv-body').value.trim() :'';

      if(!rating)          {setMsg('Please select a star rating.','error');return;}
      if(!name)            {setMsg('Please enter your name.','error');return;}
      if(!IS_LOGGED_IN&&!email){setMsg('Please enter your email address.','error');return;}
      if(!IS_LOGGED_IN&&email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){setMsg('Please enter a valid email address.','error');return;}
      if(title.length<3)   {setMsg('Review title must be at least 3 characters.','error');return;}
      if(body.length<10)   {setMsg('Review must be at least 10 characters.','error');return;}

      setSubmitLoading(sb,true);
      setMsg('','');

      // Upload locally-cached photos first, then submit the review.
      uploadPendingPhotos()
        .then(function(photoUrls){
          return fetch(BASE+'/reviews/submit',{
            method:'POST',
            headers:{'Content-Type':'application/json','X-Keplin-Auth':AUTH},
            body:JSON.stringify({
              productId:PRODUCT_ID,productHandle:PRODUCT_HANDLE,productTitle:PRODUCT_TITLE,
              customerId:CUSTOMER_ID,customerName:name,email:email||CUSTOMER_EMAIL,
              rating:rating,title:title,body:body,photos:photoUrls
            })
          }).then(function(r){return r.json().then(function(dd){return{ok:r.ok,data:dd};});});
        })
        .then(function(resp){
          if(resp.data.status==='already_reviewed'){
            setMsg('You\'ve already reviewed this product — thank you!','success');
            setSubmitLoading(sb,false);
            return;
          }
          if(!resp.ok){
            setMsg(resp.data.error||'Something went wrong.','error');
            setSubmitLoading(sb,false);
            return;
          }
          showSuccess(resp.data.discountCode);
        })
        .catch(function(err){
          setMsg((err&&err.message)||'Network error. Please try again.','error');
          setSubmitLoading(sb,false);
        });
    });
  }

  function setMsg(t,type){
    var el=$('kpln-rv-msg');if(!el)return;
    el.textContent=t;
    el.className='kpln-rv__form-msg'+(type?' kpln-rv__form-msg--'+type:'');
  }

  if(/[?&]review=1/.test(window.location.search)){
    setTimeout(function(){ openForm(); },700);
  }

  // Boot — hydrate only. #kpln-rv-list keeps its server-rendered markup
  // until the person actually filters/sorts/searches/paginates.
  renderOverall();
  renderAttrs();
  renderSummary();
  renderGallery();
  updateMetaUI();

})();
